import _defineProperty from "/builds/ametnes/cloud/content.cloud.ametnes.com/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/ametnes/cloud/content.cloud.ametnes.com/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/builds/ametnes/cloud/content.cloud.ametnes.com/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["colorSchemes", "components", "defaultColorScheme"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import deepmerge from '@mui/utils/deepmerge';
import cssVarsParser from "./cssVarsParser.js";
function prepareCssVars(theme) {
  var parserConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _parserConfig$getSele = parserConfig.getSelector,
    getSelector = _parserConfig$getSele === void 0 ? defaultGetSelector : _parserConfig$getSele,
    disableCssColorScheme = parserConfig.disableCssColorScheme,
    selector = parserConfig.colorSchemeSelector;
  // @ts-ignore - ignore components do not exist
  var _theme$colorSchemes = theme.colorSchemes,
    colorSchemes = _theme$colorSchemes === void 0 ? {} : _theme$colorSchemes,
    components = theme.components,
    _theme$defaultColorSc = theme.defaultColorScheme,
    defaultColorScheme = _theme$defaultColorSc === void 0 ? 'light' : _theme$defaultColorSc,
    otherTheme = _objectWithoutProperties(theme, _excluded);
  var _cssVarsParser = cssVarsParser(otherTheme, parserConfig),
    rootVars = _cssVarsParser.vars,
    rootCss = _cssVarsParser.css,
    rootVarsWithDefaults = _cssVarsParser.varsWithDefaults;
  var themeVars = rootVarsWithDefaults;
  var colorSchemesMap = {};
  var defaultScheme = colorSchemes[defaultColorScheme],
    otherColorSchemes = _objectWithoutProperties(colorSchemes, [defaultColorScheme].map(_toPropertyKey));
  Object.entries(otherColorSchemes || {}).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      scheme = _ref2[1];
    var _cssVarsParser2 = cssVarsParser(scheme, parserConfig),
      vars = _cssVarsParser2.vars,
      css = _cssVarsParser2.css,
      varsWithDefaults = _cssVarsParser2.varsWithDefaults;
    themeVars = deepmerge(themeVars, varsWithDefaults);
    colorSchemesMap[key] = {
      css: css,
      vars: vars
    };
  });
  if (defaultScheme) {
    // default color scheme vars should be merged last to set as default
    var _cssVarsParser3 = cssVarsParser(defaultScheme, parserConfig),
      css = _cssVarsParser3.css,
      vars = _cssVarsParser3.vars,
      varsWithDefaults = _cssVarsParser3.varsWithDefaults;
    themeVars = deepmerge(themeVars, varsWithDefaults);
    colorSchemesMap[defaultColorScheme] = {
      css: css,
      vars: vars
    };
  }
  function defaultGetSelector(colorScheme, cssObject) {
    var rule = selector;
    if (selector === 'class') {
      rule = '.%s';
    }
    if (selector === 'data') {
      rule = '[data-%s]';
    }
    if (selector !== null && selector !== void 0 && selector.startsWith('data-') && !selector.includes('%s')) {
      // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
      rule = "[".concat(selector, "=\"%s\"]");
    }
    if (colorScheme) {
      if (rule === 'media') {
        var _colorSchemes$colorSc, _colorSchemes$colorSc2;
        if (theme.defaultColorScheme === colorScheme) {
          return ':root';
        }
        var mode = ((_colorSchemes$colorSc = colorSchemes[colorScheme]) === null || _colorSchemes$colorSc === void 0 ? void 0 : (_colorSchemes$colorSc2 = _colorSchemes$colorSc.palette) === null || _colorSchemes$colorSc2 === void 0 ? void 0 : _colorSchemes$colorSc2.mode) || colorScheme;
        return _defineProperty({}, "@media (prefers-color-scheme: ".concat(mode, ")"), {
          ':root': cssObject
        });
      }
      if (rule) {
        if (theme.defaultColorScheme === colorScheme) {
          return ":root, ".concat(rule.replace('%s', String(colorScheme)));
        }
        return rule.replace('%s', String(colorScheme));
      }
    }
    return ':root';
  }
  var generateThemeVars = function generateThemeVars() {
    var vars = _objectSpread({}, rootVars);
    Object.entries(colorSchemesMap).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        schemeVars = _ref5[1].vars;
      vars = deepmerge(vars, schemeVars);
    });
    return vars;
  };
  var generateStyleSheets = function generateStyleSheets() {
    var stylesheets = [];
    var colorScheme = theme.defaultColorScheme || 'light';
    function insertStyleSheet(key, css) {
      if (Object.keys(css).length) {
        stylesheets.push(typeof key === 'string' ? _defineProperty({}, key, _objectSpread({}, css)) : key);
      }
    }
    insertStyleSheet(getSelector(undefined, _objectSpread({}, rootCss)), rootCss);
    var defaultSchemeVal = colorSchemesMap[colorScheme],
      other = _objectWithoutProperties(colorSchemesMap, [colorScheme].map(_toPropertyKey));
    if (defaultSchemeVal) {
      var _colorSchemes$colorSc3, _colorSchemes$colorSc4;
      // default color scheme has to come before other color schemes
      var _css = defaultSchemeVal.css;
      var cssColorSheme = (_colorSchemes$colorSc3 = colorSchemes[colorScheme]) === null || _colorSchemes$colorSc3 === void 0 ? void 0 : (_colorSchemes$colorSc4 = _colorSchemes$colorSc3.palette) === null || _colorSchemes$colorSc4 === void 0 ? void 0 : _colorSchemes$colorSc4.mode;
      var finalCss = !disableCssColorScheme && cssColorSheme ? _objectSpread({
        colorScheme: cssColorSheme
      }, _css) : _objectSpread({}, _css);
      insertStyleSheet(getSelector(colorScheme, _objectSpread({}, finalCss)), finalCss);
    }
    Object.entries(other).forEach(function (_ref7) {
      var _colorSchemes$key, _colorSchemes$key$pal;
      var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        css = _ref8[1].css;
      var cssColorSheme = (_colorSchemes$key = colorSchemes[key]) === null || _colorSchemes$key === void 0 ? void 0 : (_colorSchemes$key$pal = _colorSchemes$key.palette) === null || _colorSchemes$key$pal === void 0 ? void 0 : _colorSchemes$key$pal.mode;
      var finalCss = !disableCssColorScheme && cssColorSheme ? _objectSpread({
        colorScheme: cssColorSheme
      }, css) : _objectSpread({}, css);
      insertStyleSheet(getSelector(key, _objectSpread({}, finalCss)), finalCss);
    });
    return stylesheets;
  };
  return {
    vars: themeVars,
    generateThemeVars: generateThemeVars,
    generateStyleSheets: generateStyleSheets
  };
}
export default prepareCssVars;